import FadeIn from "@/components/ui/FadeIn";

const CAPABILITIES = [
  {
    num: "01",
    title: "Restatement-adjusted numbers",
    description: "Multi-period figures pulled directly from unstructured source documents.",
  },
  {
    num: "02",
    title: "Guidance modelling",
    description: "Identify subtle cues about the future.",
  },
  {
    num: "03",
    title: "AI-powered text search",
    description: "Combine AI-driven questions with comprehensive fundamentals.",
  },
  {
    num: "04",
    title: "Tone & sentiment",
    description: "Track confidence, stress, deflection and frustration.",
  },
];

const THEMES = {
  dark: {
    overline: "text-violet-400/80",
    border: "border-white/10",
    num: "text-violet-400/80",
    title: "text-white",
    description: "text-white/50",
  },
  light: {
    overline: "text-violet-800",
    border: "border-black/10",
    num: "text-violet-800/70",
    title: "text-black",
    description: "text-black/50",
  },
} as const;

export default function UniqueCapabilities({
  theme = "dark",
  delay = 0,
  className = "",
}: {
  theme?: "dark" | "light";
  delay?: number;
  className?: string;
}) {
  const t = THEMES[theme];
  return (
    <FadeIn delay={delay} className={className}>
      <p className={`max-w-5xl text-xs tracking-[0.2em] uppercase ${t.overline} font-semibold`}>
        Unique to Hudson Labs
      </p>
      <ul className={`mt-4 max-w-5xl border-t ${t.border}`}>
        {CAPABILITIES.map((item) => (
          <li
            key={item.num}
            className={`grid grid-cols-[auto_1fr] sm:grid-cols-[auto_1fr_1fr] items-start gap-x-6 sm:gap-x-10 gap-y-2 border-b ${t.border} py-8 sm:py-10`}
          >
            <span className={`text-4xl sm:text-5xl italic font-[family-name:var(--font-display)] ${t.num} leading-none`}>
              {item.num}
            </span>
            <h3 className={`text-2xl sm:text-3xl font-[family-name:var(--font-display)] tracking-[-0.02em] leading-tight ${t.title}`}>
              {item.title}
            </h3>
            <p className={`col-start-2 sm:col-start-3 text-sm sm:text-base ${t.description} leading-relaxed sm:pt-1.5`}>
              {item.description}
            </p>
          </li>
        ))}
      </ul>
    </FadeIn>
  );
}
